import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { WorkStationsForCategoryResponse, WorkStationsListDto, WorkStationsListResponseModel } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import appSettings from 'apps/services/config';
import { WorkersRepository } from './workers-repository';
import { CommonResponse } from '@gtpl/shared-models/sale-management';
import { WorkerDTO } from './dto/worker.dto';
import { WorkerEntity } from './workers.entity';
import { WorkerRequest } from './dto/worker.request';
import { getManager } from 'typeorm';
import { ContractorIdReq } from '@gtpl/shared-models/masters';

@Injectable()
export class WorkersService {
    constructor(
        @InjectRepository(WorkerEntity)
        private workerRepo: WorkersRepository,
        
    ) { }

    async createWorker(req:WorkerDTO,isUpdate: boolean):Promise<CommonResponse>{
        
        try{
            if (!isUpdate) {
                const check = await this.workerRepo.find({where:{workerCode:req.workerCode}})
                const aadharcheck = await this.workerRepo.find({where:{aadharCardNumber:req.aadharCardNumber}})

                if (check.length > 0) {
                    return new CommonResponse(false,0,'Worker Code already exists')
                } else if (aadharcheck.length > 0) {
                    return new CommonResponse(false,0,'Aadhar number already exists')
                }
            }
    
            const entity = new WorkerEntity()
            entity.workerId = req.workerId;
            entity.workerCode = req.workerCode;
            entity.workerName = req.workerName;
            entity.contractorId = req.contractorId
            entity.contractorName = req.contractorName
            entity.dateOfBirth = req.dateOfBirth
            entity.dateOfJoining = req.dateOfJoining
            entity.address = req.address
            entity.villageFrom = req.villageFrom
            entity.aadharCardNumber = req.aadharCardNumber
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;
            entity.villageFromId=req.villageFromId
            
            if(isUpdate){
      
                entity.workerId = req.workerId;
                entity.updatedUser = req.createdUser;
      
              } else{
      
                entity.createdUser = req.createdUser
            }
            const save = await this.workerRepo.save(entity)
            if(!save){
              
                return new CommonResponse(false,0,'Something went wrong in worker creation',[])
            } else{
                
                return new CommonResponse(true,1,isUpdate ? 'worker Updated Successfully' : 'worker Created Successfully',save)
            }
      
        } catch(err){
       
            throw err
        }
      }
      

    async getAllworkerData(): Promise<any> {
        try {
            const data = await this.workerRepo.find()
            if (data.length > 0) {
            return new CommonResponse(true, 1, 'data retrived Sucessfully', data)
            } else {
            return new CommonResponse(false, 0, 'No Data', [])
             
            }
        } catch (err) {
            return err;
        }
    }

    async getAllActiveworkerData(): Promise<any> {
        try {
            const data = await this.workerRepo.find({
                where:{isActive:true},
                order:{createdAt:'ASC'}
            })
            if (data.length > 0) {
            return new CommonResponse(true, 1, 'data retrived Sucessfully', data)
            } else {
            return new CommonResponse(false, 0, 'No Data', [])
             
            }
        } catch (err) {
            return err;
        }
    }


    async activateOrDeactivateworker(req: WorkerRequest): Promise<CommonResponse> {
        try {
          console.log(req.isActive,'service-----------')
            const Exists = await this.workerRepo.findOne({where:{workerId:req.workerId}});
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current worker information.Refresh and try again');
                } else {
    
                    const update = await this.workerRepo.update(
                        { workerId: req.workerId },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponse = new CommonResponse(true, 10115, 'worker is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponse(false,10111, 'worker is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponse = new CommonResponse(true, 10114, 'worker is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponse(false,10112, 'worker is already  activated');
                        }
                    }
                    
                }
            } else {
                throw new CommonResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getWorkersAgainstContractor(req:ContractorIdReq):Promise<CommonResponse>{
        const manager = getManager()
        try{
            let workersInfoQry = `SELECT worker_id AS workerId, worker_Code AS workerCode,worker_name AS 
            workerName,aadhar_card_no AS aadharCardNumber,village_name AS village,v.transport_cost as transportCost,c.contractor_name as contractorName,c.contractor_id as contractorId
            FROM ${appSettings.masters_db} .workers w
            LEFT JOIN ${appSettings.masters_db} .village_transport_cost v on v.village_transport_id = w.village_from_id
            LEFT JOIN ${appSettings.hrms_db} .contractor c on c.contractor_id = w.contractor_id
            WHERE worker_id > 0`
            if(req.contractorId != undefined){
                workersInfoQry += ` AND w.contractor_id = ${req.contractorId}`
            }
            const workersInfo = await manager.query(workersInfoQry)
            if(workersInfo.length > 0){
                return new CommonResponse(true,1,'Data retrieved',workersInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

}
